// Static asset paths served from /app/frontend/public/.
// Use a single source of truth so download CTAs are easy to update.
export const BAH_PRODUCT_CATALOGUE_PDF = "/BAH-Product-Catalogue-Aug-2025.pdf";
export const BAH_INSTRUMENTS_CATALOGUE_PDF = "/BAH-Instruments-Catalogue-2026.pdf";

// Filename hint shown to the browser when downloading.
export const BAH_PRODUCT_CATALOGUE_FILENAME =
  "BAH-Product-Catalogue-August-2025.pdf";
export const BAH_INSTRUMENTS_CATALOGUE_FILENAME =
  "BAH-Instruments-Catalogue-2026.pdf";
